module.exports = __webpack_public_path__ + "img/工艺花架-4.4e777f8d.jpg";